import React, { useContext, useEffect, useState, useRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify'; // Importation

function CreatPersonnel() {
  const navigate = useNavigate();
  let token = localStorage.getItem('accessToken');
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    nomprenom: null,
    sexe: null,
    cin: null,
    datenaisse: null,
    fonction: null,
    etsouserviceId: null,
    gradeId: null,
    compagnieId: null,
    adresseMail: null,
    delivrele: null,
    telephone: null,
    whatsapp: null,
    situationmatrimoniale: null,
    nomConjoint: null,
    a: null,
    adresseactuelle: null,
    afficheImage: null,
    observation: null,
    datemariage: null,
    dateNaissConj: null,
    lieuNaissConj: null,
    groupesanguin: null,
    groupeethnique: null,
    religion: null,
    lieu: null,
    affectionactuelle: null,
    matricule: null,
    daterecrute: null,
    indice: null,
    interruptiondu: null,
    au: null,
    sortantecole: null,
    bureautique: null,
    rupture: 'En Service',
    autres: null,
    francais: null,
    anglais: null,
    autresLangue: null,
    NumPermis: null,
    permisDelivrele: null,
    lieuDelivrance: null,
    permisCategorie: null,
    autresPermis: null,
    MatriculeFinance: null,
    des: null,
    dn: null,
    cim: null,
    nomdupere: null,
    nomdelamere: null,
    campagne: null,
    punition: null,
    affectationTemporaire: null,
    affectationDedinitive: null,
    prenomsUsuel: null,
    direction: null,
    typePers: null,
    diplomeadministratif: null,
    arme: null,
    positionexacte: null,
    situation: null,
    eleves: null,
    annee: null,
    vague: null,
    situationactuelle: null,
    interieur: null,
    valider: false,

  });

  const [listeEtsouservice, setListEtsouservice] = useState([]);
  const [listeGrade, setListGrade] = useState([]);
  //const [listeCompagnie, setListCompagnie] = useState([])

  const [brigade, setBrigade] = useState([]);
  const [bataillon, setBataillon] = useState([]);
  const [compagnie, setCompagnie] = useState([]);

  const [selectBrigade, setSelectBrigade] = useState([]);
  const [selectBataillon, setSelectBataillon] = useState([]);

  const [affectations, setAffectations] = useState([{ lieuaffect: '', fonctiontenue: '', dateeffet: null }]);
  const [enfants, setEnfants] = useState([{ nomprenom: '', datenaisse: null, sexe: '', observation: '' }]);
  const [ecole, setEcole] = useState([{ intitule: '', etablissement: '', diplome: '', annee: '' }]);
  const [avancements, setAvancements] = useState([{ statu: '', reference: '', dateeffet: null }]);
  const [promotiongrade, setPromotiongrade] = useState([{ portgrade: '', datepromotion: null, gradeId: '' }]);
  const [decorations, setDecoration] = useState([]);
  const [listeDecoration, setListeDecoration] = useState([{ decretouarrete: '', dateObtention: null, decorationId: '' }]);
  const [operations, setOperations] = useState([
    {
      corpsunites: '',
      bataillonoudss: '',
      observation: '',
      boadssId: '',
    },
  ]);
  const [boaDss, setBoaDss] = useState([]);

  const [imagePreview, setImagePreview] = useState(''); // For storing the preview URL
  const [file, setFile] = useState(null); // For storing the preview URL
  const [message, setMessage] = useState(''); // For storing the preview URL
  const [error, setError] = useState(''); // For storing the preview URL

  useEffect(() => {
    axios.get('/etsouservice').then((res) => {
      setListEtsouservice(res.data);
    });

    axios.get('/grade').then((res) => {
      setListGrade(res.data);
    });

    // axios.get('/compagnie').then((res) => {
    //     setListCompagnie(res.data)
    // })

    axios.get('/brigade').then((res) => {
      setBrigade(res.data);
    });

    axios.get('/bataillon').then((res) => {
      setBataillon(res.data);
    });
    axios.get('/decoration').then((res) => {
      setDecoration(res.data);
    });
    axios.get('/boadss').then((response) => {
      setBoaDss(response.data);
    });
  }, []);

  useEffect(() => {
    if (selectBrigade) {
      axios.get(`bataillon/${selectBrigade}`).then((res) => setBataillon(res.data));
    }
  }, [selectBrigade]);

  useEffect(() => {
    if (selectBataillon) {
      axios.get(`compagnie/${selectBataillon}`).then((res) => setCompagnie(res.data.compagnie));
    }
  }, [selectBataillon]);

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;

    if (type === 'file') {
      const file = files[0];
      if (file) {
        setFile(e.target.files[0]);

        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setFile(null);
        setImagePreview('');
      }
    } else if (type === 'checkbox') {
      setFormData({ ...formData, [name]: e.target.checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }


    if (name === 'arme') {
      setFormData({
        ...formData,
        arme: value,
        gradeId: '', // reset du grade
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

  };

  const handleAddAffection = () => {
    setAffectations([...affectations, { lieuaffect: '', fonctiontenue: '', dateeffet: '' }]);
  };
  const handleRemoveAffectation = (index) => {
    const newAffectations = affectations.filter((_, i) => i !== index);
    setAffectations(newAffectations);
  };
  const handleAddAffectionChange = (index, e) => {
    const { name, value } = e.target;
    const newAffectations = affectations.map((affectation, i) => {
      if (i === index) {
        return { ...affectation, [name]: value };
      }
      return affectation;
    });
    setAffectations(newAffectations);
  };

  const handleAddEnfant = () => {
    setEnfants([...enfants, { nomprenom: '', datenaisse: '', sexe: '', observation: '' }]);
  };
  const handleRemoveEnfant = (index) => {
    const newEnfant = enfants.filter((_, i) => i !== index);
    setEnfants(newEnfant);
  };
  const handleAddEnfantChange = (index, e) => {
    const { name, value } = e.target;
    const newEnfant = enfants.map((enfant, i) => {
      if (i === index) {
        return { ...enfant, [name]: value };
      }
      return enfant;
    });
    setEnfants(newEnfant);
  };

  const handleAddPromotionGrade = () => {
    setPromotiongrade([...promotiongrade, { portgrade: '', datepromotion: null, gradeId: '' }]);
  };
  const handleRemovePromotionGrade = (index) => {
    const newPromotionGrade = promotiongrade.filter((_, i) => i !== index);
    setPromotiongrade(newPromotionGrade);
  };
  const handleAddPromotionGradeChange = (index, e) => {
    const { name, value } = e.target;
    const newPromotion = promotiongrade.map((promotiongrade, i) => {
      if (i === index) {
        return { ...promotiongrade, [name]: value };
      }
      return promotiongrade;
    });
    setPromotiongrade(newPromotion);
  };

  const handleAddEcole = () => {
    setEcole([...ecole, { intitule: '', etablissement: '', diplome: '', annee: '' }]);
  };
  const handleRemoveEcole = (index) => {
    const newEcole = ecole.filter((_, i) => i !== index);
    setEcole(newEcole);
  };
  const handleAddEcoleChange = (index, e) => {
    const { name, value } = e.target;
    const newEcole = ecole.map((ecole, i) => {
      if (i === index) {
        return { ...ecole, [name]: value };
      }
      return ecole;
    });
    setEcole(newEcole);
  };

  const handleAddAvancement = () => {
    setAvancements([...avancements, { statu: '', reference: '', dateeffet: '' }]);
  };
  const handleRemoveAvancement = (index) => {
    const newAvancement = avancements.filter((_, i) => i !== index);
    setAvancements(newAvancement);
  };
  const handleAddAvancementChange = (index, e) => {
    const { name, value } = e.target;
    const newAvancement = avancements.map((avancement, i) => {
      if (i === index) {
        return { ...avancement, [name]: value };
      }
      return avancement;
    });
    setAvancements(newAvancement);
  };

  const handleAddDecoration = () => {
    setListeDecoration([...listeDecoration, { decretouarrete: '', dateObtention: '', decorationId: '' }]);
  };
  const handleRemoveDecoration = (index) => {
    const newDecoration = listeDecoration.filter((_, i) => i !== index);
    setListeDecoration(newDecoration);
  };
  const handleAddDecorationChange = (index, e) => {
    const { name, value } = e.target;
    const newDecoration = listeDecoration.map((deco, i) => {
      if (i === index) {
        return { ...deco, [name]: value };
      }
      return deco;
    });
    setListeDecoration(newDecoration);
    //   console.log(newDecoration);
  };

  // Ajouter une nouvelle opération
  const handleAddOperation = () => {
    setOperations([
      ...operations,
      {
        corpsunites: '',
        bataillonoudss: '',
        observation: '',
        boadssId: '',
      },
    ]);
  };

  // Supprimer une opération existante
  const handleRemoveOperation = (index) => {
    const newOperations = operations.filter((_, i) => i !== index);
    setOperations(newOperations);
  };

  // Gérer le changement dans un champ d'opération
  const handleAddOperationChange = (index, e) => {
    const { name, value } = e.target;
    const newOperations = operations.map((operation, i) => {
      if (i === index) {
        return { ...operation, [name]: value };
      }
      return operation;
    });
    setOperations(newOperations);
  };

  const checkboxRef = useRef(null);

  const enregistrer = async (e) => {
    e.preventDefault();
    if (loading) return; // bloque double clic

    if (!formData['valider']) {
      toast.warn('Veuillez valider votre enregistrement', {
        position: 'bottom-right',
      });
      checkboxRef.current.focus();
      return;
    }
    setLoading(true); // bloque bouton

    const data = new FormData();

    /*     for (const key in formData) {
      let value = formData[key];
      data.append(key, value);

    } */

    data.append('affectations', JSON.stringify(affectations));
    data.append('enfants', JSON.stringify(enfants));
    data.append('ecole', JSON.stringify(ecole));
    data.append('avancements', JSON.stringify(avancements));
    data.append('decorations', JSON.stringify(listeDecoration));
    data.append('operations', JSON.stringify(operations));
    data.append('personnelData', JSON.stringify(formData));
    data.append('promotiongrade', JSON.stringify(promotiongrade));

    if (file) {
      const fixedImageName = `${formData.nomprenom}_${file.name}`;
      data.append('file', file, fixedImageName);
    }

    try {
      const response = await axios.post('/personnel', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        toast.success('Personnel créé avec succès !', {
          position: 'bottom-right',
        });
        setTimeout(() => {
          navigate('/personnel');
        }, 2000);
      }
    } catch (error) {
      toast.error(error.response.data.error);
    } finally {
      setLoading(false);
    }
  };

  const gradesFiltres = listeGrade.filter((grade) => {
    if (!formData.arme) return false;

    if (formData.arme === 'TERRE') return grade.name;
    if (formData.arme === 'MER') return grade.grademer;
    if (formData.arme === 'AIR') return grade.gradeair;

    return false;
  });

  const getGradeLabel = (grade) => {
    if (formData.arme === 'TERRE') return grade.name;
    if (formData.arme === 'AIR') return grade.gradeair;
    if (formData.arme === 'MER') return grade.grademer;
    return '';
  };

  return (
    <div className="max-w-7xl mx-auto pt-3 mt-5 border border-gray-200 p-2 rounded-xl">
      <div className="">
        <div className="col bg-warning ">
          <h3>Nouveau enregistrement</h3>
        </div>
      </div>
      {/* initialValues={initialValues} validationSchema={validation} */}
      <form onSubmit={enregistrer}>
        <fieldset className="border border-warning custom-fieldset rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            BRCA
          </legend>
          <div className="row mb-3 ml-3 mr-3">
            <div className="col">
              <label htmlFor="arme">Armé de : </label>
              <select onChange={handleChange} id="arme" name="arme" className="form-control">
                <option value=""></option>
                <option value="TERRE">TERRE</option>
                <option value="MER">MER</option>
                <option value="AIR">AIR</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="brigade">Brigade : </label>
              <select value={selectBrigade} onChange={(e) => setSelectBrigade(e.target.value)} id="brigade" name="brigade" className="form-control">
                <option value=""></option>
                {brigade.map((brigade, key) => {
                  return (
                    <option key={key} value={brigade.id}>
                      {brigade.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col">
              <label htmlFor="brigade">Bataillon : </label>
              <select value={selectBataillon} onChange={(e) => setSelectBataillon(e.target.value)} id="bataillon" name="bataillon" className="form-control">
                <option value=""></option>
                {selectBrigade.length > 0
                  ? bataillon.map((bataillon, key) => {
                    return (
                      <option key={key} value={bataillon.id}>
                        {bataillon.name}
                      </option>
                    );
                  })
                  : ''}
              </select>
            </div>
            <div className="col">
              <label htmlFor="compagnie">Compagnie : </label>
              <select onChange={handleChange} id="compagnieId" name="compagnieId" className="form-control">
                <option value=""></option>
                {selectBataillon.length > 0
                  ? compagnie.map((compagnie, key) => {
                    return (
                      <option key={key} value={compagnie.id}>
                        {compagnie.name}
                      </option>
                    );
                  })
                  : ''}
              </select>
            </div>
          </div>
        </fieldset>


        <fieldset className="border border-warning custom-fieldset custom-fieldset rounded  "  >
          <legend className="w-auto px-4 text-primary ">
            Identité
          </legend>

          <div className="row">
            <div className="col">
              <label htmlFor="nomprenom">Nom et prénoms : </label>
              <input type="text" name="nomprenom" placeholder="nom et prénoms" value={formData['nomprenom']} onChange={handleChange} className="form-control" required />
            </div>
            <div className="col-md-3">
              <label htmlFor="grade">Grade :</label>
              <select
                onChange={handleChange}
                id="gradeId"
                name="gradeId"
                className="form-control"
                value={formData.gradeId}
                disabled={!formData.arme}
              >
                <option value="">
                  {formData.arme ? 'Sélectionner un grade' : 'Choisir d’abord l’Armé'}
                </option>

                {gradesFiltres.map((grade) => (
                  <option key={grade.id} value={grade.id}>
                    {getGradeLabel(grade)}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <label htmlFor="fonction">Fonction : </label>
              <input type="text" onChange={handleChange} id="fonction" name="fonction" className="form-control" />
            </div>

          </div>
          <div className='row'>
            <div className="col">
              <label htmlFor="etsouservice">Ets. ou service :</label>
              <select onChange={handleChange} id="etsouserviceId" name="etsouserviceId" className="form-control">
                {/* multiple="multiple" */}
                <option value=""></option>
                {listeEtsouservice.map((etsouservice, key) => {
                  return (
                    <option key={key} value={etsouservice.id}>
                      {etsouservice.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col">
              <label htmlFor="sexe">Sexe :</label>
              <select className="form-control" onChange={handleChange} id="sexe" name="sexe">
                <option value=""></option>
                <option value="H">H</option>
                <option value="F">F</option>
              </select>
            </div>

            <div className="col">
              <label htmlFor="datenaisse">Date de naissance : </label>
              <input type="date" onChange={handleChange} id="datenaisse" name="datenaisse" className="form-control" />
            </div>


            <div className="col">
              <label htmlFor="lieu">Lieu de naissance : </label>
              <input className="form-control" type="text" name="lieu" id="lieu" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="indice">Indice : </label>
              <input className="form-control" type="text" name="indice" id="indice" onChange={handleChange} />
            </div>

          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="daterecrute">Date d'entré en service : </label>
              <input className="form-control" type="text" name="daterecrute" id="daterecrute" onChange={handleChange} />
            </div>


            <div className="col">
              <label htmlFor="cin">CIN :</label>
              <input type="text" onChange={handleChange} id="cin" name="cin" maxLength={12} minLength={12} pattern="[0-9]{12}" inputMode="numeric" className="form-control" />
              {/* <input
              type="text"
              onChange={(e) => {
                const value = e.target.value;
                // N'autorise que les chiffres, max 12
                if (/^\d{0,12}$/.test(value)) {
                  handleChange(e);
                }
              }}
              id="cin"
              name="cin"
              className="form-control"
              maxLength={12}
            /> */}
            </div>

            <div className="col">
              <label htmlFor="delivrele">Délivré le : </label>
              <input className="form-control" type="date" name="delivrele" id="delivrele" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="a">à : </label>
              <input className="form-control" type="text" name="a" id="a" onChange={handleChange} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="matricule">Matricule : </label>
              <input className="form-control" type="text" name="matricule" id="matricule" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="telephone">Téléphone : </label>
              <input className="form-control" type="text" name="telephone" id="telephone" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="whatsapp">Whatsapp : </label>
              <input className="form-control" type="text" name="whatsapp" id="whatsapp" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="adresseMail">Mail : </label>
              <input className="form-control" type="text" name="adresseMail" id="adresseMail" onChange={handleChange} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="direction">Direction : </label>
              <select name="direction" id="direction" onChange={handleChange} className="form-control" required>
                <option value=""></option>
                <option value="DCCA">DCCA</option>
                <option value="Autres">Autres</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="adresseactuelle">Adresse :</label>
              <input type="text" onChange={handleChange} id="adresseactuelle" name="adresseactuelle" className="form-control" />
            </div>

            <div className="col">
              <label htmlFor="nomdupere">Nom du père : </label>
              <input className="form-control" type="text" name="nomdupere" id="nomdupere" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="nomdelamere">Nom du mère : </label>
              <input className="form-control" type="text" name="nomdelamere" id="nomdelamere" onChange={handleChange} />
            </div>
          </div>

        </fieldset>

        <fieldset className="border border-warning custom-fieldset border-3 rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            Epoux(se)
          </legend>
          <div className="row m-2 p-2 ">
            <div className="col ">
              <label htmlFor="situationmatrimoniale">Situation matrimoniale :</label>
              <select onChange={handleChange} name="situationmatrimoniale" id="situationmatrimoniale" className="form-control" required>
                <option value=""></option>
                <option value="MARIE">Marié</option>
                <option value="DIVORCE">Divorcé</option>
                <option value="CELIBATAIRE">Célibataire</option>
                <option value="VEUF">Veuf(ve)</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="nomConjoint">Nom et prénoms </label>
              <input className="form-control" type="text" name="nomConjoint" id="nomConjoint" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="datemariage">Date mariage : </label>
              <input className="form-control" type="date" name="datemariage" id="datemariage" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="dateNaissConj">Date de naissance </label>
              <input className="form-control" type="date" name="dateNaissConj" id="dateNaissConj" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="lieuNaissConj">lieu de naissance : </label>
              <input className="form-control" type="text" name="lieuNaissConj" id="lieuNaissConj" onChange={handleChange} />
            </div>
          </div>
        </fieldset>

        <fieldset className="border border-warning custom-fieldset border-3 rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            Connaissances en Informatique
          </legend>
          <div className="row">
            <div className="col">
              <input type="checkbox" name="bureautique" id="bureautique" onChange={handleChange} />
              <label htmlFor="bureautique"> Bureautique ? </label>
            </div>
            <div className="col">
              <label htmlFor="autres">Autres connaissance INFO : </label>
              <input className="form-control" type="text" name="autres" id="autres" onChange={handleChange} />
            </div>
          </div>
        </fieldset>



        {/*  <div className="row">
          <div className="col">
            <label htmlFor="groupesanguin">Groupe sanguin : </label>
            <input className="form-control" type="text" name="groupesanguin" id="groupesanguin" onChange={handleChange} />
          </div>
          <div className="col">
            <label htmlFor="groupeethnique">Groupe Ethnique : </label>
            <input className="form-control" type="text" name="groupeethnique" id="groupeethnique" onChange={handleChange} />
          </div>
          <div className="col">
            <label htmlFor="religion">Religion : </label>
            <input className="form-control" type="text" name="religion" id="religion" onChange={handleChange} />
          </div>
        </div> */}
        {/*    <div className="row">
          <div className="col">
            <label htmlFor="affectionactuelle">Affection actuelle : </label>
            <input className="form-control" type="text" name="affectionactuelle" id="affectionactuelle" onChange={handleChange} />
          </div>


        </div> */}

        {/*         <div className="row">
          <div className="col">
            <label htmlFor="interruptiondu">Interruption du : </label>
            <input className="form-control" type="date" name="interruptiondu" id="interruptiondu" onChange={handleChange} />
          </div>
          <div className="col">
            <label htmlFor="au">Au : </label>
            <input className="form-control" type="date" name="au" id="au" onChange={handleChange} />
          </div>

        </div> */}
        <fieldset className="border border-warning custom-fieldset border-3 rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            Connaissances linguistiques
          </legend>
          <div className='row' >
            <div className="col">
              <label htmlFor="francais">Français</label>
              <select onChange={handleChange} id="francais" name="francais" className="form-control">
                <option value=""></option>
                <option value="Débutant">Débutant</option>
                <option value="Moyen">Moyen</option>
                <option value="Avancé">Avancé</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="anglais">Anglais</label>
              <select onChange={handleChange} id="anglais" name="anglais" className="form-control">
                <option value=""></option>
                <option value="Débutant">Débutant</option>
                <option value="Moyen">Moyen</option>
                <option value="Avancé">Avancé</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="autresLangue">Autres langue: </label>
              <input className="form-control" type="text" name="autresLangue" id="autresLangue" onChange={handleChange} />
            </div>
          </div>

        </fieldset>


        <fieldset className="border border-warning custom-fieldset border-3 rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            Aptitudes particuliers
          </legend>
          <div className="row">
            <div className="col">
              <label htmlFor="NumPermis"> Numéro Permis : </label>
              <input className="form-control" type="text" name="NumPermis" id="NumPermis" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="permisDelivrele">Permis Délivré le : </label>
              <input className="form-control" type="date" name="permisDelivrele" id="permisDelivrele" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="lieuDelivrance">lieu de délivrance : </label>
              <input className="form-control" type="text" name="lieuDelivrance" id="lieuDelivrance" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="permisCategorie">Categorie : </label>
              <input className="form-control" type="text" name="permisCategorie" id="permisCategorie" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="autresPermis">Autres Compétance : </label>
              <input className="form-control" type="text" name="autresPermis" id="autresPermis" onChange={handleChange} />
            </div>
          </div>
        </fieldset>




        <div className="row">
          <div className="col-md-4">
            <label htmlFor="file">Image : </label>
            {/* <ErrorMessage className='text-danger' name='file' component='span' />
                                <Field onChange={handleChangeFile} type="file" name="file" id="file" className='form-control' /> */}
            <input type="file" name="file" onChange={handleChange} />
          </div>
          <div className="row">{imagePreview && <img src={imagePreview} alt="Current" style={{ width: '150px', height: '150px' }} />}</div>
        </div>

        <fieldset className="border border-warning custom-fieldset border-3 rounded" style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary">
            INFORMATION MILITAIRE
          </legend>
          <div className=" p-3 mt-3">
            <div className="row">
              <div className="col">
                <label htmlFor="MatriculeFinance">Matricule Finance : </label>
                <input className="form-control" type="text" name="MatriculeFinance" id="MatriculeFinance" onChange={handleChange} />
              </div>
              <div className="col">
                <label htmlFor="diplomeadministratif">Spécialité : </label>
                <select onChange={handleChange} id="diplomeadministratif" name="diplomeadministratif" className="form-control">
                  <option value=""></option>
                  <option value="TRESORIER">TRESORIER</option>
                  <option value="INFANTERIE">INFANTERIE</option>
                  <option value="CHANCELLERIE">CHANCELLERIE</option>
                  <option value="TRANSMISSION">TRANSMISSION</option>
                  <option value="INFORMATICIEN">INFORMATICIEN</option>
                  <option value="MECANICIEN">MECANICIEN</option>
                  <option value="ELECTRICIEN">ELECTRICIEN</option>
                  <option value="ADMINISTRATION">ADMINISTRATION</option>
                  <option value="MEDECIN">MEDECIN</option>
                </select>
              </div>
              {/* <div className="col">
              <label htmlFor="des">DES : </label>
              <input className="form-control" type="date" name="des" id="des" onChange={handleChange} />
            </div> */}
              {/* <div className="col">
              <label htmlFor="dn">DN : </label>
              <input className="form-control" type="text" name="dn" id="dn" onChange={handleChange} />
            </div> */}
              <div className="col">
                <label htmlFor="cim">CIM : </label>
                <input className="form-control" type="text" name="cim" id="cim" onChange={handleChange} />
              </div>

              <div className="col">
                <label htmlFor="campagne">Campagne : </label>
                <input className="form-control" type="text" name="campagne" id="campagne" onChange={handleChange} />
              </div>
            </div>

            <div className="row">

              <div className="col">
                <label htmlFor="punition">Punition : </label>
                <input className="form-control" type="text" name="punition" id="punition" onChange={handleChange} />
              </div>
              <div className="col">
                <label htmlFor="affectationTemporaire">Affectation Temporaire :</label>
                <input className="form-control" type="text" name="affectationTemporaire" id="affectationTemporaire" onChange={handleChange} />
              </div>

              <div className="col">
                <label htmlFor="affectationDedinitive">Affectation Definitive :</label>
                <input className="form-control" type="text" name="affectationDedinitive" id="affectationDedinitive" onChange={handleChange} />
              </div>


              <div className="col">
                <label htmlFor="positionexacte">Position exacte : </label>
                <input className="form-control" type="text" name="positionexacte" id="positionexacte" onChange={handleChange} />
              </div>

            </div>
            <div className="row">
            </div>
            <div className="row">
              <div className="col">
                <label htmlFor="eleves">Eleves : </label>
                <select onChange={handleChange} id="eleves" name="eleves" className="form-control">
                  <option value=""></option>
                  <option value="EOD">EOD</option>
                  <option value="ELD">ELD</option>
                  <option value="ECO">ECO</option>
                </select>
              </div>
              <div className="col">
                <label htmlFor="prenomsUsuel">Prénoms Usuel : </label>
                <input className="form-control" type="text" name="prenomsUsuel" id="prenomsUsuel" onChange={handleChange} />
              </div>
              <div className="col">
                <label htmlFor="sortantecole">Sortant d'ecole : </label>
                <input className="form-control" type="text" name="sortantecole" id="sortantecole" onChange={handleChange} />
              </div>

            </div>

            {!formData.matricule && (
              <div className="row mt-4">
                <div className="col-md-6">
                  <fieldset className="border bg-light">
                    <legend className="w-auto px-2 fw-bold">PDL</legend>
                    <div className="row mb-3 mx-3">
                      <div className="col d-flex align-items-center">
                        <label htmlFor="annee" className="me-2 mb-0">Année :</label>
                        <select
                          id="annee"
                          name="annee"
                          onChange={handleChange}
                          className="form-control"
                          style={{ maxWidth: "120px" }} // ajuste la largeur du select
                        >
                          <option value=""></option>
                          <option value="2023">2023</option>
                          <option value="2024">2024</option>
                          <option value="2025">2025</option>
                          <option value="2026">2026</option>
                          <option value="2027">2027</option>
                        </select>
                      </div>

                      <div className="col d-flex align-items-center">
                        <label htmlFor="vague" className="me-2 mb-0">Vague :</label>
                        <select
                          id="vague"
                          name="vague"
                          onChange={handleChange}
                          className="form-control"
                          style={{ maxWidth: "80px" }} // ajuste la largeur du select
                        >
                          <option value=""></option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                        </select>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            )}
          </div>
        </fieldset>


        <hr />
        <div className="">
          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li className="nav-item">
              <a className="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-affectation" role="tab" aria-controls="pills-home" aria-selected="true">
                Affectations Succ.
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-enfant" role="tab" aria-controls="pills-profile" aria-selected="false">
                Enfants
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-ecole" role="tab" aria-controls="pills-contact" aria-selected="false">
                Ecoles/Stages
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-avancement" role="tab" aria-controls="pills-contact" aria-selected="false">
                Avancements
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-decoration" role="tab" aria-controls="pills-contact" aria-selected="false">
                Décorations
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-promotion" role="tab" aria-controls="pills-contact" aria-selected="false">
                Grade Succ.
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-mouvement-tab" data-toggle="pill" href="#pills-mouvement" role="tab" aria-controls="pills-mouvement" aria-selected="false">
                Opération/Stagiaire/Détaché
              </a>
            </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active col" id="pills-affectation" role="tabpanel" aria-labelledby="pills-home-tab">
              {/* affectationsuccessive */}
              <div className="row">
                <div className="col">
                  <h2>Affectations Successives</h2>
                  {affectations.map((affectation, index) => (
                    <div key={index}>
                      <div className="row">
                        <div className="col">
                          <label htmlFor="lieuaffect">Lieu Affect.</label>
                          <input
                            value={affectation.lieuaffect}
                            onChange={(e) => {
                              handleAddAffectionChange(index, e);
                            }}
                            type="text"
                            id="lieuaffect"
                            name="lieuaffect"
                            className="form-control"
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="fonctiontenue">Fonction tenue.</label>
                          <input
                            value={affectation.fonctiontenue}
                            onChange={(e) => {
                              handleAddAffectionChange(index, e);
                            }}
                            type="text"
                            id="fonctiontenue"
                            name="fonctiontenue"
                            className="form-control"
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="dateeffet">Date Effet.</label>
                          <input
                            value={affectation.dateeffet}
                            onChange={(e) => {
                              handleAddAffectionChange(index, e);
                            }}
                            type="date"
                            id="dateeffet"
                            name="dateeffet"
                            className="form-control"
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="decisionaffectation">Décision d'affectation.</label>
                          <input
                            value={affectation.decisionaffectation}
                            onChange={(e) => {
                              handleAddAffectionChange(index, e);
                            }}
                            type="text"
                            id="decisionaffectation"
                            name="decisionaffectation"
                            className="form-control"
                          />
                        </div>
                        <i onClick={() => handleRemoveAffectation(index)} className="fa fa-trash fa-1x "></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="text-right row mt-2">
                <div className="col">
                  <button className="btn btn-primary" type="button" onClick={handleAddAffection}>
                    Ajout affectation
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-enfant" role="tabpanel" aria-labelledby="pills-profile-tab">
              <div className="col">
                <h2>Enfant</h2>
                {enfants.map((enfant, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="lieuaffect">Nom et prénoms.</label>
                        <input
                          value={enfant.nomprenom}
                          onChange={(e) => {
                            handleAddEnfantChange(index, e);
                          }}
                          type="text"
                          id="nomprenom"
                          name="nomprenom"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="fonctiontenue">Date de naissance.</label>
                        <input
                          value={enfant.datenaisse}
                          onChange={(e) => {
                            handleAddEnfantChange(index, e);
                          }}
                          type="date"
                          id="datenaisse"
                          name="datenaisse"
                          className="form-control"
                        />
                      </div>

                      <div className="col">
                        <label htmlFor="sexe">Sexe.</label>
                        <select
                          value={enfant.sexe}
                          onChange={(e) => {
                            handleAddEnfantChange(index, e);
                          }}
                          className="form-control"
                          id="sexe"
                          name="sexe"
                        >
                          <option value=""></option>
                          <option value="1">H</option>
                          <option value="2">F</option>
                        </select>
                      </div>

                      <div className="col">
                        <label htmlFor="dateeffet">Observation.</label>
                        <select
                          value={enfant.observation}
                          onChange={(e) => {
                            handleAddEnfantChange(index, e);
                          }}
                          id="observation"
                          name="observation"
                          className="form-control"
                        >
                          <option value=""></option>
                          <option value="LEGITIME">LEGITIME</option>
                          <option value="RECONUE">RECONUE</option>
                          <option value="ADOPTE">ADOPTE</option>
                        </select>
                      </div>
                      <i onClick={() => handleRemoveEnfant(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row">
                <div className=" col text-right">
                  <button className="btn btn-primary" type="button" onClick={handleAddEnfant}>
                    Ajout Enfant
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-ecole" role="tabpanel" aria-labelledby="pills-contact-tab">
              <div className="col">
                <h2>Ecole</h2>
                {ecole.map((ecole, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="intitule">Intitulé.</label>
                        <input
                          value={ecole.intitule}
                          onChange={(e) => {
                            handleAddEcoleChange(index, e);
                          }}
                          type="text"
                          id="intitule"
                          name="intitule"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="etablissement">Etablissement.</label>
                        <input
                          value={ecole.etablissement}
                          onChange={(e) => {
                            handleAddEcoleChange(index, e);
                          }}
                          type="text"
                          id="etablissement"
                          name="etablissement"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="diplome">Diplôme.</label>
                        <input
                          value={ecole.diplome}
                          onChange={(e) => {
                            handleAddEcoleChange(index, e);
                          }}
                          type="text"
                          id="diplome"
                          name="diplome"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="annee">Année.</label>
                        <input
                          value={ecole.annee}
                          onChange={(e) => {
                            handleAddEcoleChange(index, e);
                          }}
                          type="text"
                          id="annee"
                          name="annee"
                          className="form-control"
                        />
                      </div>
                      <i onClick={() => handleRemoveEcole(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row">
                <div className=" col text-right">
                  <button className="btn btn-primary" type="button" onClick={handleAddEcole}>
                    Ajout Ecole
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-avancement" role="tabpanel" aria-labelledby="pills-contact-tab">
              <div className="col">
                <h2>Avancements</h2>
                {avancements.map((avancement, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="statu">Statu.</label>
                        <input
                          value={avancement.statu}
                          onChange={(e) => {
                            handleAddAvancementChange(index, e);
                          }}
                          type="text"
                          id="statu"
                          name="statu"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="reference">Référence.</label>
                        <input
                          value={avancement.reference}
                          onChange={(e) => {
                            handleAddAvancementChange(index, e);
                          }}
                          type="text"
                          id="reference"
                          name="reference"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="dateeffet">Date Effet.</label>
                        <input
                          value={avancement.dateeffet}
                          onChange={(e) => {
                            handleAddAvancementChange(index, e);
                          }}
                          type="date"
                          id="dateeffet"
                          name="dateeffet"
                          className="form-control"
                        />
                      </div>
                      <i onClick={() => handleRemoveAvancement(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row">
                <div className=" col text-right">
                  <button className="btn btn-primary" type="button" onClick={handleAddAvancement}>
                    Ajout Avancement
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-decoration" role="tabpanel" aria-labelledby="pills-contact-tab">
              <div className="col">
                <h2>Décoration</h2>
                {listeDecoration.map((decoration, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="decretouarrete">Décret ou Arrete.</label>
                        <input
                          value={decoration.decretouarrete}
                          onChange={(e) => {
                            handleAddDecorationChange(index, e);
                          }}
                          type="text"
                          id="decretouarrete"
                          name="decretouarrete"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="dateObtention">Date.</label>
                        <input
                          value={decoration.dateObtention}
                          onChange={(e) => {
                            handleAddDecorationChange(index, e);
                          }}
                          type="date"
                          id="dateObtention"
                          name="dateObtention"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor={`decoration-id-${index}`}>{index}Décoration :</label>
                        <select id={`decoration-id-${index}`} value={decoration.id} onChange={(e) => handleAddDecorationChange(index, e)} className="form-control" name="decorationId">
                          {/* multiple="multiple" */}
                          <option value="">Séléctionnez le décoration</option>
                          {decorations.map((decoration, key) => {
                            return (
                              <option key={key} value={decoration.id}>
                                {decoration.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <i onClick={() => handleRemoveDecoration(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row">
                <div className="col text-right">
                  <button className="btn btn-primary" type="button" onClick={handleAddDecoration}>
                    Ajout Décoration
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-promotion" role="tabpanel" aria-labelledby="pills-promotion-tab">
              <div className="col">
                <h2>Promotion de grade</h2>
                {promotiongrade.map((promotiongrade, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="datepromotion">Date de promotion :</label>
                        <input
                          value={promotiongrade.datepromotion}
                          onChange={(e) => {
                            handleAddPromotionGradeChange(index, e);
                          }}
                          type="date"
                          id="datepromotion"
                          name="datepromotion"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="portgrade">Port de grade :</label>
                        <input
                          value={promotiongrade.portgrade}
                          onChange={(e) => {
                            handleAddPromotionGradeChange(index, e);
                          }}
                          type="text"
                          id="portgrade"
                          name="portgrade"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="grade">Grade : </label>
                        <select
                          value={promotiongrade.gradeId}
                          onChange={(e) => {
                            handleAddPromotionGradeChange(index, e);
                          }}
                          id="gradeId"
                          name="gradeId"
                          className="form-control"
                        >
                          <option value=""></option>
                          {listeGrade.map((grade, key) => {
                            return (
                              <option key={key} value={grade.id}>
                                {grade.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <i onClick={() => handleRemovePromotionGrade(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row">
                <div className=" col text-right">
                  <button className="btn btn-primary mt-4 " type="button" onClick={handleAddPromotionGrade}>
                    Ajout Promotion Grade
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-mouvement" role="tabpanel" aria-labelledby="pills-mouvement-tab">
              <div className="col">
                <h2>Opérations</h2>
                {operations.map((operation, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label>Lieu :</label>
                        <select className="form-control" name="boadssId" value={operation.boadssId} onChange={(e) => handleAddOperationChange(index, e)}>
                          <option value="">Sélectionner BOA OU DSS</option>
                          {boaDss.map((boadss) => (
                            <option key={boadss.id} value={boadss.id}>
                              {boadss.bataillonoudss}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col">
                        <label htmlFor="observation">Situation :</label>
                        <select
                          value={operation.observation}
                          onChange={(e) => {
                            handleAddOperationChange(index, e);
                          }}
                          id="observation"
                          name="observation"
                          className="form-control"
                        >
                          <option value=""></option>
                          <option value="MILITAIRE EN OPERATIONS">MILITAIRE EN OPERATIONS</option>
                          <option value="MILITAIRES DETACHES">MILITAIRES DETACHES</option>
                          <option value="STAGIAIRES INTERIEUR">STAGIAIRES INTERIEUR</option>
                          <option value="STAGIAIRES EXTERIEUR">STAGIAIRES EXTERIEUR</option>
                        </select>
                      </div>
                      <div className="col">
                        <label htmlFor="dateDebut">Date début :</label>
                        <input
                          value={operation.dateDebut}
                          onChange={(e) => {
                            handleAddOperationChange(index, e);
                          }}
                          type="date"
                          name="dateDebut"
                          id="dateDebut"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="dateFin">Date fin :</label>
                        <input
                          value={operation.dateFin}
                          onChange={(e) => {
                            handleAddOperationChange(index, e);
                          }}
                          type="date"
                          name="dateFin"
                          id="dateFin"
                          className="form-control"
                        />
                      </div>
                      <i onClick={() => handleRemoveOperation(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row">
                <div className=" col text-right mt-3 ">
                  <button className="btn btn-primary" type="button" onClick={handleAddOperation}>
                    Ajout Opération
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-3 d-flex justify-content-start">
          <div className='col-md-6'>
            <div className="col d-flex align-items-center">
              <label htmlFor="affectionactuelle" className="me-2 mb-0">Vérification :</label>
              <select
                id="affectionactuelle"
                name="affectionactuelle"
                onChange={handleChange}
                className="form-control "
                style={{ maxWidth: "150px" }}
              >
                <option value=""></option>
                <option value="VERIFIER">VERIFIER</option>
              </select>
            </div>
            <br />
            <div className="col d-flex align-items-center">
              <label htmlFor="valider" className="me-2 mb-0 mr-1">Valider l'enregistrement ?</label>
              <input style={{ transform: 'scale(1.6)', cursor: 'pointer' }} className="me-2 mr-3" type="checkbox" checked={formData['valider']} onChange={handleChange} id="flexCheckChecked" name="valider" ref={checkboxRef} />
              {formData['valider'] ? <span> J'accepte cet anregistrement </span> : null}

            </div>
          </div>
        </div>





        <div className="row">
          <div className="col">
            {message && <p style={{ color: 'green' }}>{message}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </div>
        </div>
        <div className="row">
          <div className="col">
            {/*  <button type="submit" className="btn btn-success mt-4" disabled={loading} >
              Enregistrer
            </button>
 */}
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
            >
              {loading ? "Enregistrement..." : "Enregistrer"}
            </button>


          </div>
        </div>
        {/* <span className='col-md-6'> {JSON.stringify(formData)} </span> */}
      </form>
    </div>
  );
}

export default CreatPersonnel;
